module.exports = __webpack_public_path__ + "img/VPS-Service.9fcc841.svg";